const PRODUCT_STATUS = Object.freeze({
  CREATED: 'created',
  PENDING_ACTIVE: 'pendingActive',
  CANCELLED: 'cancelled',
  ACTIVE: 'active',
  PENDING_TERMINATE: 'pendingTerminate',
  TERMINATED: 'terminated',
  SUSPENDED: 'suspended',
  ABORTED: 'aborted',
});

const ORDER_STATE = Object.freeze({
  PENDING: 'PENDING',
  CANCELLED: 'CANCELLED',
  REJECTED: 'REJECTED',
  INPROGRESS: 'INPROGRESS',
  COMPLETED: 'COMPLETED',
});

export { PRODUCT_STATUS, ORDER_STATE };
